export const IconPointingfinger = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M10.532 6.314h.073c.567 0 1.03.463 1.03 1.03v6.625h.667v-2.775a.96.96 0 0 1 .957-.957h.073c.566 0 1.03.464 1.03 1.03v2.775l.032-.011h.722v-2.112a.96.96 0 0 1 .956-.956h.073c.567 0 1.03.463 1.03 1.03v1.93l.01.003.714-.005v-1.364a.96.96 0 0 1 .957-.957h.073c.566 0 1.03.464 1.03 1.03v2.887q0 .054-.006.105l.034.029c.063 1.86-.064 4.526-1.595 5.857-1.518 1.233-3.038 1.557-4.613 1.31-2.15-.339-3.27-1.504-4.289-3.354l-4.032-6.393c-.21-.494-.182-.83.03-1.045.909-.59 2.39.663 4.03 2.436l.06-.014V7.27a.96.96 0 0 1 .954-.956m.626-2.768a.506.506 0 1 1-1.012 0l-.004-2.04a.506.506 0 1 1 1.012 0zM6.546 7.728a.506.506 0 1 1 0 1.013h-2.04a.506.506 0 1 1 0-1.013zm1.447-3.027a.507.507 0 0 1-.718.715L5.834 3.972a.507.507 0 0 1 .718-.714zm6.663 4.041a.506.506 0 1 1 0-1.012l2.04-.002a.506.506 0 1 1 0 1.013zm-.727-3.437a.507.507 0 0 1-.718-.714l1.441-1.444a.507.507 0 0 1 .718.715z"
        clipRule="evenodd"
      />
    </svg>
  );
};
